module.exports = __webpack_public_path__ + "static/media/imgAllDone.838efb1e.svg";